<template lang="pug">
.bg-black.bg-opacity-5.dark_bg-white.dark_bg-opacity-5.px-1.py-1.flex.hover_bg-opacity-5.rounded-md.h-10.items-center.text-gray-800.dark_text-gray-100
  template(v-for="k in layouts")
    button.ripple.ripple--centered.px-2(
      :class="layout === k ? 'text-primary-700 dark_text-primary-300' : 'opacity-50 hover_opacity-100'"
      :title="iconMap[k].name"
      @click="() => setLayout(k)"
      type="button"
    )
      span.text-2xl(v-html="iconMap[k].svg")
</template>

<script setup lang="ts">
import IconPane0 from '../icons/uc-ph-pane-0.svg?raw';
import IconPane1 from '../icons/uc-ph-pane-1.svg?raw';
import IconPane2 from '../icons/uc-ph-pane-2.svg?raw';
import IconPane3 from '../icons/uc-ph-pane-3.svg?raw';
import IconPopup1 from '../icons/uc-ph-popup-1.svg?raw';
import IconPopup2 from '../icons/uc-ph-popup-2.svg?raw';
import { layout, setLayout } from '../lib/useEditorPanes';
import { computed } from 'vue';

const props = defineProps<{ isUbercourse: boolean }>();

const iconMap: Record<EditorLayout, { svg: string; name: string }> = {
  'pane-0': { svg: IconPane0, name: '1 Editor' },
  'pane-1': { svg: IconPane1, name: '1 Editor, Pane' },
  'pane-2': { svg: IconPane2, name: '2 Editors, Pane' },
  'pane-3': { svg: IconPane3, name: '2 Editors' },
  'popup-1': { svg: IconPopup1, name: '1 Editor, Popup' },
  'popup-2': { svg: IconPopup2, name: '2 Editors, Popup' }
};

const layouts = computed(() => {
  // if ubercourse remove the conversational only layouts
  if (props.isUbercourse)
    return Object.keys(iconMap).filter(
      k => k !== 'pane-3' && k !== 'pane-0'
    ) as EditorLayout[];

  // for conversational only layouts
  return ['pane-0', 'pane-3'] as EditorLayout[];
});

// const activeIcon = computed(() => iconMap[layout.value].svg);
</script>
